import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-statistic',
  template: `<router-outlet></router-outlet>`,
  styleUrls: ['./statistic.component.css']
})
export class StatisticComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/statistic/statistic.component.ts